// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import CollectionsService from '../../services/collectionsService';
// import ToastService from '../../services/toastService';
// import Sidebar from '../Sidebar/Sidebar';

// const Collections = () => {
//   const navigate = useNavigate();
  
//   // State Management
//   const [loading, setLoading] = useState(true);
//   const [collections, setCollections] = useState([]);
//   const [filteredCollections, setFilteredCollections] = useState([]);
//   const [error, setError] = useState('');
  
//   // Sidebar State
//   const [sidebarOpen, setSidebarOpen] = useState(false);
  
//   // Filter State
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchInput, setSearchInput] = useState('');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
  
//   // Sorting State
//   const [sortField, setSortField] = useState('createdAt');
//   const [sortDirection, setSortDirection] = useState('desc');

//   // Pull to refresh states
//   const [refreshing, setRefreshing] = useState(false);
//   const [pullDistance, setPullDistance] = useState(0);
//   const touchStartY = useRef(0);
//   const containerRef = useRef(null);
//   const searchTimeoutRef = useRef(null);

//   // Initialize
//   useEffect(() => {
//     fetchCollections();
    
//     // Set default dates - empty start date, end date to today
//     const today = new Date();
    
//     setStartDate(''); // Empty start date
//     setEndDate(today.toISOString().split('T')[0]); // Today
//   }, []);

//   // Debounced search
//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(() => {
//       setSearchTerm(searchInput);
//     }, 500);

//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchInput]);

//   // Handle search
//   useEffect(() => {
//     if (collections.length > 0) {
//       handleSearch();
//     }
//   }, [searchTerm, startDate, endDate, collections]);

//   // Pull to refresh handlers
//   const handleTouchStart = (e) => {
//     if (containerRef.current && containerRef.current.scrollTop === 0) {
//       touchStartY.current = e.touches[0].clientY;
//     }
//   };

//   const handleTouchMove = (e) => {
//     if (refreshing) return;
    
//     const touchY = e.touches[0].clientY;
//     const pull = touchY - touchStartY.current;
    
//     if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
//       e.preventDefault();
//       setPullDistance(Math.min(pull, 100));
//     }
//   };

//   const handleTouchEnd = () => {
//     if (pullDistance > 60) {
//       handleRefresh();
//     }
//     setPullDistance(0);
//   };

//   const handleRefresh = async () => {
//     setRefreshing(true);
//     try {
//       await fetchCollections();
//       ToastService.success('Collections refreshed', 1500);
//     } catch (error) {
//       ToastService.error('Refresh failed');
//     } finally {
//       setTimeout(() => setRefreshing(false), 500);
//     }
//   };

//   // Fetch collections data
//   const fetchCollections = async () => {
//     try {
//       setLoading(true);
//       setError('');
      
//       console.log('Fetching collections...');
//       const response = await CollectionsService.getCollections();
//       console.log('API Response:', response);
      
//       // Handle API response format {success: true, message: "...", data: [...], pagination: {...}}
//       let collectionsData = [];
      
//       if (response.success === true && Array.isArray(response.data)) {
//         // Format matches your API: {success: true, data: [...]}
//         collectionsData = response.data;
//       } else if (Array.isArray(response)) {
//         // Direct array response
//         collectionsData = response;
//       } else {
//         // Fallback to empty array
//         collectionsData = [];
//         console.warn('Unexpected response format:', response);
//       }
      
//       console.log('Processed collections data:', collectionsData);
      
//       if (!Array.isArray(collectionsData)) {
//         throw new Error('Invalid data format received from server');
//       }
      
//       setCollections(collectionsData);
//       setFilteredCollections(collectionsData);
      
//     } catch (error) {
//       console.error('Error fetching collections:', error);
//       const errorMessage = error.message || 'Failed to load collections data';
//       setError(errorMessage);
//       ToastService.error(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = () => {
//     let filtered = [...collections];
    
//     // Apply search term filter
//     if (searchTerm.trim()) {
//       const term = searchTerm.toLowerCase();
//       filtered = filtered.filter(item => {
//         if (!item) return false;
        
//         // Search in collection fields
//         const codeMatch = item.code && item.code.toLowerCase().includes(term);
//         const amountMatch = String(item.amount || '').includes(term);
//         const statusMatch = item.status && item.status.toLowerCase().includes(term);
        
//         // Search in credit fields
//         const creditIdMatch = item.credit?.id && String(item.credit.id).includes(term);
//         const creditAmountMatch = item.credit?.amount && String(item.credit.amount).includes(term);
        
//         // Search in customer fields
//         const customerNameMatch = item.credit?.customer?.name && 
//           item.credit.customer.name.toLowerCase().includes(term);
//         const customerIdMatch = item.credit?.customer?.id && 
//           String(item.credit.customer.id).includes(term);
        
//         // Search in sales person fields
//         const salesPersonNameMatch = item.salePerson?.firstName && 
//           item.salePerson.firstName.toLowerCase().includes(term);
//         const salesPersonIdMatch = item.salePerson?.id && 
//           String(item.salePerson.id).includes(term);
        
//         return codeMatch || amountMatch || statusMatch || 
//                creditIdMatch || creditAmountMatch || 
//                customerNameMatch || customerIdMatch || 
//                salesPersonNameMatch || salesPersonIdMatch;
//       });
//     }
    
//     // Apply date filters
//     if (startDate) {
//       const start = new Date(startDate);
//       filtered = filtered.filter(item => {
//         if (!item || !item.createdAt) return false;
//         const itemDate = new Date(item.createdAt);
//         return itemDate >= start;
//       });
//     }
    
//     if (endDate) {
//       const end = new Date(endDate);
//       end.setHours(23, 59, 59, 999);
//       filtered = filtered.filter(item => {
//         if (!item || !item.createdAt) return false;
//         const itemDate = new Date(item.createdAt);
//         return itemDate <= end;
//       });
//     }
    
//     setFilteredCollections(filtered);
//   };

//   // Handle sort
//   const handleSort = (field) => {
//     const direction = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
//     setSortField(field);
//     setSortDirection(direction);
    
//     const sorted = [...filteredCollections].sort((a, b) => {
//       let aValue = a[field];
//       let bValue = b[field];
      
//       // Handle dates
//       if (field.includes('Date') || field === 'createdAt') {
//         aValue = aValue ? new Date(aValue) : new Date(0);
//         bValue = bValue ? new Date(bValue) : new Date(0);
//       }
      
//       // Handle numbers
//       if (field === 'amount') {
//         aValue = parseFloat(aValue) || 0;
//         bValue = parseFloat(bValue) || 0;
//       }
      
//       // Handle strings
//       if (typeof aValue === 'string') {
//         aValue = aValue.toLowerCase();
//         bValue = bValue ? bValue.toLowerCase() : '';
//       }
      
//       if (aValue < bValue) return direction === 'asc' ? -1 : 1;
//       if (aValue > bValue) return direction === 'asc' ? 1 : -1;
//       return 0;
//     });
    
//     setFilteredCollections(sorted);
//   };

//   // Clear filters
//   const handleClearFilters = () => {
//     setSearchInput('');
//     setSearchTerm('');
    
//     // Reset to default dates - empty start date, end date to today
//     const today = new Date();
    
//     setStartDate(''); // Empty start date
//     setEndDate(today.toISOString().split('T')[0]); // Today
    
//     setFilteredCollections(collections);
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     const num = parseFloat(amount) || 0;
//     return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };

//   // Format date with time
//   const formatDateTime = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return 'Invalid Date';
      
//       return date.toLocaleString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch (e) {
//       return 'Invalid Date';
//     }
//   };

//   // Format date only
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return 'Invalid Date';
      
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric'
//       });
//     } catch (e) {
//       return 'Invalid Date';
//     }
//   };

//   // Get status badge color
//   const getStatusColor = (status) => {
//     if (!status) return 'bg-gray-100 text-gray-700';
    
//     const statusUpper = status.toUpperCase();
//     if (statusUpper === 'PAID') return 'bg-green-100 text-green-700';
//     if (statusUpper === 'PARTIALLY_PAID') return 'bg-yellow-100 text-yellow-700';
//     if (statusUpper === 'PENDING') return 'bg-orange-100 text-orange-700';
//     if (statusUpper === 'CANCELLED' || statusUpper === 'FAILED') return 'bg-red-100 text-red-700';
//     return 'bg-gray-100 text-gray-700';
//   };

//   // Get status badge text
//   const getStatusText = (status) => {
//     if (!status) return 'Unknown';
    
//     const statusUpper = status.toUpperCase();
//     switch (statusUpper) {
//       case 'PAID':
//         return 'Paid';
//       case 'PARTIALLY_PAID':
//         return 'Partially Paid';
//       case 'PENDING':
//         return 'Pending';
//       case 'CANCELLED':
//         return 'Cancelled';
//       case 'FAILED':
//         return 'Failed';
//       default:
//         return status;
//     }
//   };

//   // Calculate summary
//   const calculateSummary = () => {
//     const totalAmount = filteredCollections.reduce((sum, item) => {
//       return sum + (parseFloat(item?.amount) || 0);
//     }, 0);
    
//     const totalCollections = filteredCollections.length;
//     const paidCollections = filteredCollections.filter(item => 
//       item?.status?.toUpperCase() === 'PAID'
//     ).length;
    
//     const partialCollections = filteredCollections.filter(item => 
//       item?.status?.toUpperCase() === 'PARTIALLY_PAID'
//     ).length;
    
//     const pendingCollections = filteredCollections.filter(item => 
//       item?.status?.toUpperCase() === 'PENDING'
//     ).length;
    
//     // Calculate total credit amount
//     const totalCreditAmount = filteredCollections.reduce((sum, item) => {
//       return sum + (parseFloat(item?.credit?.amount) || 0);
//     }, 0);
    
//     return {
//       totalAmount,
//       totalCollections,
//       paidCollections,
//       partialCollections,
//       pendingCollections,
//       totalCreditAmount
//     };
//   };

//   const summary = calculateSummary();

//   // Handle view collection details
//   const handleViewCollection = (id) => {
//     navigate(`/collections/${id}`);
//   };

//   // Render loading state
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading collections data...</p>
//         </div>
//       </div>
//     );
//   }

//   // Render error state
//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//         <div className="text-center max-w-md">
//           <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
//             <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//             </svg>
//           </div>
//           <h3 className="text-xl font-bold text-gray-900 mb-2">Error Loading Collections</h3>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <button 
//             className="px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105"
//             style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//             onClick={fetchCollections}
//           >
//             <svg className="w-5 h-5 inline-block mr-2 -mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//             </svg>
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div 
//       ref={containerRef}
//       className="min-h-screen bg-gray-50 overflow-y-auto"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
//       {sidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}

//       {/* Pull to Refresh Indicator */}
//       {pullDistance > 0 && (
//         <div 
//           className="fixed top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-50"
//           style={{ 
//             transform: `translateY(${pullDistance}px)`,
//             opacity: pullDistance / 100 
//           }}
//         >
//           <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
//             <svg 
//               className="w-5 h-5 text-blue-600" 
//               fill="none" 
//               stroke="currentColor" 
//               viewBox="0 0 24 24"
//             >
//               <path 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round" 
//                 strokeWidth={2} 
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
//               />
//             </svg>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
//         <div className="px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center gap-3 sm:gap-4">
//               <button 
//                 className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
//                 onClick={() => setSidebarOpen(true)}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//               <h1 className="text-lg sm:text-xl font-semibold text-white">Collections</h1>
//             </div>
            
//             <button
//               onClick={fetchCollections}
//               disabled={loading}
//               className="px-3 sm:px-4 py-2 rounded-lg bg-white/20 text-white font-medium hover:bg-white/30 disabled:opacity-60 disabled:cursor-not-allowed transition-all text-sm sm:text-base"
//             >
//               <svg 
//                 className={`w-4 h-4 sm:w-5 sm:h-5 inline-block mr-1 sm:mr-2 -mt-0.5 ${loading ? 'animate-spin' : ''}`}
//                 fill="none" 
//                 stroke="currentColor" 
//                 viewBox="0 0 24 24"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//               </svg>
//               <span className="hidden sm:inline">Refresh</span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
        
//         {/* Summary Cards */}
//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
//           <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center flex-shrink-0">
//                 <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//               <div className="flex-1 min-w-0">
//                 <p className="text-xs sm:text-sm text-gray-500 mb-1">Total Collected</p>
//                 <p className="text-base sm:text-lg font-bold text-gray-900 truncate">{formatCurrency(summary.totalAmount)}</p>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center flex-shrink-0">
//                 <svg className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
//                 </svg>
//               </div>
//               <div className="flex-1 min-w-0">
//                 <p className="text-xs sm:text-sm text-gray-500 mb-1">Total Credit</p>
//                 <p className="text-base sm:text-lg font-bold text-gray-900 truncate">{formatCurrency(summary.totalCreditAmount)}</p>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center flex-shrink-0">
//                 <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                 </svg>
//               </div>
//               <div className="flex-1 min-w-0">
//                 <p className="text-xs sm:text-sm text-gray-500 mb-1">Collections</p>
//                 <p className="text-base sm:text-lg font-bold text-gray-900">{summary.totalCollections}</p>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center flex-shrink-0">
//                 <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//               <div className="flex-1 min-w-0">
//                 <p className="text-xs sm:text-sm text-gray-500 mb-1">Paid</p>
//                 <p className="text-base sm:text-lg font-bold text-gray-900">{summary.paidCollections}</p>
//                 {summary.partialCollections > 0 && (
//                   <p className="text-xs text-gray-500">+{summary.partialCollections} partial</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 mb-6 border border-gray-100">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//             <h3 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center gap-2">
//               <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
//               </svg>
//               Filters
//             </h3>
//             <button 
//               className="px-3 sm:px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//               onClick={handleClearFilters}
//               disabled={!searchInput && !startDate && !endDate}
//             >
//               Clear Filters
//             </button>
//           </div>

//           <div className="space-y-4">
//             {/* Search */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Search Collections
//               </label>
//               <div className="relative">
//                 <input
//                   type="text"
//                   className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="Search by code, customer, amount, ID..."
//                   value={searchInput}
//                   onChange={(e) => setSearchInput(e.target.value)}
//                 />
//                 <svg 
//                   className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
//                   fill="none" 
//                   stroke="currentColor" 
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                 </svg>
//               </div>
//             </div>

//             {/* Date Range */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                 </svg>
//                 Date Range
//               </label>
//               <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
//                 <input
//                   type="date"
//                   className="flex-1 px-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                 />
//                 <span className="hidden sm:block text-gray-500 text-sm">to</span>
//                 <input
//                   type="date"
//                   className="flex-1 px-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Results Info */}
//           <div className="mt-4 pt-4 border-t border-gray-200">
//             <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
//               <span>
//                 Showing <span className="font-semibold text-gray-900">{filteredCollections.length}</span> of <span className="font-semibold text-gray-900">{collections.length}</span> collections
//               </span>
//               {searchInput && (
//                 <span className="px-2 py-1 rounded-md bg-blue-100 text-blue-700 text-xs font-medium">
//                   Search: "{searchInput}"
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Collections List */}
//         {filteredCollections.length === 0 ? (
//           <div className="bg-white rounded-xl shadow-md p-12 text-center border border-gray-100">
//             <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
//               <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//               </svg>
//             </div>
//             <h3 className="text-xl font-bold text-gray-900 mb-2">No collections found</h3>
//             <p className="text-gray-600 mb-6">No collections matching your criteria</p>
//             <button
//               onClick={handleClearFilters}
//               className="px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105"
//               style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//             >
//               Clear Filters
//             </button>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
//             {filteredCollections.map((collection, index) => (
//               <div 
//                 key={collection.id || index}
//                 className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100 cursor-pointer"
//                 onClick={() => handleViewCollection(collection.id)}
//               >
//                 {/* Card Header */}
//                 <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
//                   <div className="flex items-center gap-2 text-white">
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                     </svg>
//                     <span className="text-xs font-medium truncate">{collection.code || 'N/A'}</span>
//                   </div>
//                   <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(collection.status)}`}>
//                     {getStatusText(collection.status)}
//                   </span>
//                 </div>

//                 {/* Card Body */}
//                 <div className="p-4 space-y-4">
//                   {/* Amount */}
//                   <div>
//                     <div className="flex items-center gap-2 mb-2">
//                       <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                       </svg>
//                       <span className="text-xs text-gray-500 font-medium">Collection Amount</span>
//                     </div>
//                     <p className="text-lg font-bold text-green-600">{formatCurrency(collection.amount)}</p>
//                   </div>

//                   {/* Customer */}
//                   {collection.credit?.customer && (
//                     <div>
//                       <div className="flex items-center gap-2 mb-2">
//                         <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                         </svg>
//                         <span className="text-xs text-gray-500 font-medium">Customer</span>
//                       </div>
//                       <p className="text-sm font-semibold text-gray-900">{collection.credit.customer.name || 'Unknown'}</p>
//                       <p className="text-xs text-gray-500">ID: {collection.credit.customer.id || 'N/A'}</p>
//                     </div>
//                   )}

//                   {/* Credit Details */}
//                   <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
//                     <div>
//                       <div className="text-xs text-gray-500 mb-1">Credit ID</div>
//                       <div className="text-sm font-semibold text-gray-900">#{collection.credit?.id || 'N/A'}</div>
//                     </div>
//                     <div>
//                       <div className="text-xs text-gray-500 mb-1">Credit Total</div>
//                       <div className="text-sm font-semibold text-purple-600">{formatCurrency(collection.credit?.amount || 0)}</div>
//                     </div>
//                   </div>

//                   {/* Sales Person */}
//                   {collection.salePerson && (
//                     <div className="pt-3 border-t border-gray-100">
//                       <div className="flex items-center gap-2 mb-2">
//                         <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                         </svg>
//                         <span className="text-xs text-gray-500 font-medium">Sales Person</span>
//                       </div>
//                       <p className="text-sm font-semibold text-gray-900">{collection.salePerson.firstName || 'Unknown'}</p>
//                       <p className="text-xs text-gray-500">ID: {collection.salePerson.id || 'N/A'}</p>
//                     </div>
//                   )}

//                   {/* Date */}
//                   <div className="pt-3 border-t border-gray-100">
//                     <div className="flex items-center gap-2 mb-1">
//                       <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                       </svg>
//                       <span className="text-xs text-gray-500 font-medium">Collection Date</span>
//                     </div>
//                     <p className="text-sm font-semibold text-gray-900">{formatDate(collection.createdAt)}</p>
//                     <p className="text-xs text-gray-500">
//                       {new Date(collection.createdAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </main>
//     </div>
//   );
// };

// export default Collections;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CollectionsService from '../../services/collectionsService';
import ToastService from '../../services/toastService';
import Sidebar from '../Sidebar/Sidebar';

const Collections = () => {
  const navigate = useNavigate();
  
  // State Management
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [error, setError] = useState('');
  
  // Sidebar State
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Filter State
  const [searchTerm, setSearchTerm] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  
  // Sorting State
  const [sortField, setSortField] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');

  // Pull to refresh states
  const [refreshing, setRefreshing] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const touchStartY = useRef(0);
  const containerRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  // Initialize
  useEffect(() => {
    fetchCollections();
    
    // Set default dates - empty start date, end date to today
    const today = new Date();
    
    setStartDate(''); // Empty start date
    setEndDate(today.toISOString().split('T')[0]); // Today
  }, []);

  // Debounced search
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSearchTerm(searchInput);
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchInput]);

  // Handle search
  useEffect(() => {
    if (collections.length > 0) {
      handleSearch();
    }
  }, [searchTerm, startDate, endDate, collections]);

  // Pull to refresh handlers
  const handleTouchStart = (e) => {
    if (containerRef.current && containerRef.current.scrollTop === 0) {
      touchStartY.current = e.touches[0].clientY;
    }
  };

  const handleTouchMove = (e) => {
    if (refreshing) return;
    
    const touchY = e.touches[0].clientY;
    const pull = touchY - touchStartY.current;
    
    if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
      e.preventDefault();
      setPullDistance(Math.min(pull, 100));
    }
  };

  const handleTouchEnd = () => {
    if (pullDistance > 60) {
      handleRefresh();
    }
    setPullDistance(0);
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await fetchCollections();
      ToastService.success('Collections refreshed', 1500);
    } catch (error) {
      ToastService.error('Refresh failed');
    } finally {
      setTimeout(() => setRefreshing(false), 500);
    }
  };

  // Fetch collections data
  const fetchCollections = async () => {
    try {
      setLoading(true);
      setError('');
      
      console.log('Fetching collections...');
      const response = await CollectionsService.getCollections();
      console.log('API Response:', response);
      
      // Handle API response format {success: true, message: "...", data: [...], pagination: {...}}
      let collectionsData = [];
      
      if (response.success === true && Array.isArray(response.data)) {
        // Format matches your API: {success: true, data: [...]}
        collectionsData = response.data;
      } else if (Array.isArray(response)) {
        // Direct array response
        collectionsData = response;
      } else {
        // Fallback to empty array
        collectionsData = [];
        console.warn('Unexpected response format:', response);
      }
      
      console.log('Processed collections data:', collectionsData);
      
      if (!Array.isArray(collectionsData)) {
        throw new Error('Invalid data format received from server');
      }
      
      setCollections(collectionsData);
      setFilteredCollections(collectionsData);
      
    } catch (error) {
      console.error('Error fetching collections:', error);
      const errorMessage = error.message || 'Failed to load collections data';
      setError(errorMessage);
      ToastService.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    let filtered = [...collections];
    
    // Apply search term filter
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(item => {
        if (!item) return false;
        
        // Search in collection fields
        const codeMatch = item.code && item.code.toLowerCase().includes(term);
        const amountMatch = String(item.amount || '').includes(term);
        const statusMatch = item.status && item.status.toLowerCase().includes(term);
        
        // Search in credit fields
        const creditIdMatch = item.credit?.id && String(item.credit.id).includes(term);
        const creditAmountMatch = item.credit?.amount && String(item.credit.amount).includes(term);
        
        // Search in customer fields
        const customerNameMatch = item.credit?.customer?.name && 
          item.credit.customer.name.toLowerCase().includes(term);
        const customerIdMatch = item.credit?.customer?.id && 
          String(item.credit.customer.id).includes(term);
        
        // Search in sales person fields
        const salesPersonNameMatch = item.salePerson?.firstName && 
          item.salePerson.firstName.toLowerCase().includes(term);
        const salesPersonIdMatch = item.salePerson?.id && 
          String(item.salePerson.id).includes(term);
        
        return codeMatch || amountMatch || statusMatch || 
               creditIdMatch || creditAmountMatch || 
               customerNameMatch || customerIdMatch || 
               salesPersonNameMatch || salesPersonIdMatch;
      });
    }
    
    // Apply date filters
    if (startDate) {
      const start = new Date(startDate);
      filtered = filtered.filter(item => {
        if (!item || !item.createdAt) return false;
        const itemDate = new Date(item.createdAt);
        return itemDate >= start;
      });
    }
    
    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      filtered = filtered.filter(item => {
        if (!item || !item.createdAt) return false;
        const itemDate = new Date(item.createdAt);
        return itemDate <= end;
      });
    }
    
    setFilteredCollections(filtered);
  };

  // Handle sort
  const handleSort = (field) => {
    const direction = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortDirection(direction);
    
    const sorted = [...filteredCollections].sort((a, b) => {
      let aValue = a[field];
      let bValue = b[field];
      
      // Handle dates
      if (field.includes('Date') || field === 'createdAt') {
        aValue = aValue ? new Date(aValue) : new Date(0);
        bValue = bValue ? new Date(bValue) : new Date(0);
      }
      
      // Handle numbers
      if (field === 'amount') {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }
      
      // Handle strings
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue ? bValue.toLowerCase() : '';
      }
      
      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    
    setFilteredCollections(sorted);
  };

  // Clear filters
  const handleClearFilters = () => {
    setSearchInput('');
    setSearchTerm('');
    
    // Reset to default dates - empty start date, end date to today
    const today = new Date();
    
    setStartDate(''); // Empty start date
    setEndDate(today.toISOString().split('T')[0]); // Today
    
    setFilteredCollections(collections);
  };

  // Format currency
  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };

  // Format date with time
  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid Date';
      
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return 'Invalid Date';
    }
  };

  // Format date only
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid Date';
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return 'Invalid Date';
    }
  };

  // Get status badge color
  const getStatusColor = (status) => {
    if (!status) return 'bg-gray-100 text-gray-700';
    
    const statusUpper = status.toUpperCase();
    if (statusUpper === 'PAID') return 'bg-green-100 text-green-700';
    if (statusUpper === 'PARTIALLY_PAID') return 'bg-yellow-100 text-yellow-700';
    if (statusUpper === 'PENDING') return 'bg-orange-100 text-orange-700';
    if (statusUpper === 'CANCELLED' || statusUpper === 'FAILED') return 'bg-red-100 text-red-700';
    return 'bg-gray-100 text-gray-700';
  };

  // Get status badge text
  const getStatusText = (status) => {
    if (!status) return 'Unknown';
    
    const statusUpper = status.toUpperCase();
    switch (statusUpper) {
      case 'PAID':
        return 'Paid';
      case 'PARTIALLY_PAID':
        return 'Partially Paid';
      case 'PENDING':
        return 'Pending';
      case 'CANCELLED':
        return 'Cancelled';
      case 'FAILED':
        return 'Failed';
      default:
        return status;
    }
  };

  // Calculate summary
  const calculateSummary = () => {
    const totalAmount = filteredCollections.reduce((sum, item) => {
      return sum + (parseFloat(item?.amount) || 0);
    }, 0);
    
    const totalCollections = filteredCollections.length;
    const paidCollections = filteredCollections.filter(item => 
      item?.status?.toUpperCase() === 'PAID'
    ).length;
    
    const partialCollections = filteredCollections.filter(item => 
      item?.status?.toUpperCase() === 'PARTIALLY_PAID'
    ).length;
    
    const pendingCollections = filteredCollections.filter(item => 
      item?.status?.toUpperCase() === 'PENDING'
    ).length;
    
    // Calculate total credit amount
    const totalCreditAmount = filteredCollections.reduce((sum, item) => {
      return sum + (parseFloat(item?.credit?.amount) || 0);
    }, 0);
    
    return {
      totalAmount,
      totalCollections,
      paidCollections,
      partialCollections,
      pendingCollections,
      totalCreditAmount
    };
  };

  const summary = calculateSummary();

  // ── BUG FIX: guard against undefined/null id before navigating ──
  // Previously: navigate(`/collections/${id}`) with no guard caused
  // navigation to `/collections/undefined` which fell through to dashboard.
  const handleViewCollection = (e, collection) => {
    e.stopPropagation(); // prevent any parent click bubbling
    const id = collection?.id ?? collection?.collectionId ?? collection?.credit?.id;
    if (!id) {
      console.warn('Collection id is undefined, cannot navigate', collection);
      ToastService.error('Unable to open collection: missing ID');
      return;
    }
    navigate(`/collections/${id}`);
  };

  // Render loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading collections data...</p>
        </div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Error Loading Collections</h3>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            className="px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
            onClick={fetchCollections}
          >
            <svg className="w-5 h-5 inline-block mr-2 -mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="min-h-screen bg-gray-50 overflow-y-auto"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Pull to Refresh Indicator */}
      {pullDistance > 0 && (
        <div 
          className="fixed top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-50"
          style={{ 
            transform: `translateY(${pullDistance}px)`,
            opacity: pullDistance / 100 
          }}
        >
          <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
            <svg 
              className="w-5 h-5 text-blue-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
              />
            </svg>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3 sm:gap-4">
              <button 
                className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <h1 className="text-lg sm:text-xl font-semibold text-white">Collections</h1>
            </div>
            
            <button
              onClick={fetchCollections}
              disabled={loading}
              className="px-3 sm:px-4 py-2 rounded-lg bg-white/20 text-white font-medium hover:bg-white/30 disabled:opacity-60 disabled:cursor-not-allowed transition-all text-sm sm:text-base"
            >
              <svg 
                className={`w-4 h-4 sm:w-5 sm:h-5 inline-block mr-1 sm:mr-2 -mt-0.5 ${loading ? 'animate-spin' : ''}`}
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              <span className="hidden sm:inline">Refresh</span>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
        
        {/* Summary Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
          <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm text-gray-500 mb-1">Total Collected</p>
                <p className="text-base sm:text-lg font-bold text-gray-900 truncate">{formatCurrency(summary.totalAmount)}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm text-gray-500 mb-1">Total Credit</p>
                <p className="text-base sm:text-lg font-bold text-gray-900 truncate">{formatCurrency(summary.totalCreditAmount)}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm text-gray-500 mb-1">Collections</p>
                <p className="text-base sm:text-lg font-bold text-gray-900">{summary.totalCollections}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm text-gray-500 mb-1">Paid</p>
                <p className="text-base sm:text-lg font-bold text-gray-900">{summary.paidCollections}</p>
                {summary.partialCollections > 0 && (
                  <p className="text-xs text-gray-500">+{summary.partialCollections} partial</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 mb-6 border border-gray-100">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center gap-2">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              Filters
            </h3>
            <button 
              className="px-3 sm:px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              onClick={handleClearFilters}
              disabled={!searchInput && !startDate && !endDate}
            >
              Clear Filters
            </button>
          </div>

          <div className="space-y-4">
            {/* Search */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Search Collections
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Search by code, customer, amount, ID..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <svg 
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            {/* Date Range */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Date Range
              </label>
              <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
                <input
                  type="date"
                  className="flex-1 px-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <span className="hidden sm:block text-gray-500 text-sm">to</span>
                <input
                  type="date"
                  className="flex-1 px-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Results Info */}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
              <span>
                Showing <span className="font-semibold text-gray-900">{filteredCollections.length}</span> of <span className="font-semibold text-gray-900">{collections.length}</span> collections
              </span>
              {searchInput && (
                <span className="px-2 py-1 rounded-md bg-blue-100 text-blue-700 text-xs font-medium">
                  Search: "{searchInput}"
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Collections List */}
        {filteredCollections.length === 0 ? (
          <div className="bg-white rounded-xl shadow-md p-12 text-center border border-gray-100">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
              <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">No collections found</h3>
            <p className="text-gray-600 mb-6">No collections matching your criteria</p>
            <button
              onClick={handleClearFilters}
              className="px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105"
              style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
            >
              Clear Filters
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {filteredCollections.map((collection, index) => (
              <div 
                key={collection.id || index}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100 cursor-pointer"
                onClick={(e) => handleViewCollection(e, collection)}
              >
                {/* Card Header */}
                <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
                  <div className="flex items-center gap-2 text-white">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span className="text-xs font-medium truncate">{collection.code || 'N/A'}</span>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(collection.status)}`}>
                    {getStatusText(collection.status)}
                  </span>
                </div>

                {/* Card Body */}
                <div className="p-4 space-y-4">
                  {/* Amount */}
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-xs text-gray-500 font-medium">Collection Amount</span>
                    </div>
                    <p className="text-lg font-bold text-green-600">{formatCurrency(collection.amount)}</p>
                  </div>

                  {/* Customer */}
                  {collection.credit?.customer && (
                    <div>
                      <div className="flex items-center gap-2 mb-2">
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <span className="text-xs text-gray-500 font-medium">Customer</span>
                      </div>
                      <p className="text-sm font-semibold text-gray-900">{collection.credit.customer.name || 'Unknown'}</p>
                      <p className="text-xs text-gray-500">ID: {collection.credit.customer.id || 'N/A'}</p>
                    </div>
                  )}

                  {/* Credit Details */}
                  <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Credit ID</div>
                      <div className="text-sm font-semibold text-gray-900">#{collection.credit?.id || 'N/A'}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Credit Total</div>
                      <div className="text-sm font-semibold text-purple-600">{formatCurrency(collection.credit?.amount || 0)}</div>
                    </div>
                  </div>

                  {/* Sales Person */}
                  {collection.salePerson && (
                    <div className="pt-3 border-t border-gray-100">
                      <div className="flex items-center gap-2 mb-2">
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <span className="text-xs text-gray-500 font-medium">Sales Person</span>
                      </div>
                      <p className="text-sm font-semibold text-gray-900">{collection.salePerson.firstName || 'Unknown'}</p>
                      <p className="text-xs text-gray-500">ID: {collection.salePerson.id || 'N/A'}</p>
                    </div>
                  )}

                  {/* Date */}
                  <div className="pt-3 border-t border-gray-100">
                    <div className="flex items-center gap-2 mb-1">
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span className="text-xs text-gray-500 font-medium">Collection Date</span>
                    </div>
                    <p className="text-sm font-semibold text-gray-900">{formatDate(collection.createdAt)}</p>
                    <p className="text-xs text-gray-500">
                      {new Date(collection.createdAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Collections;